import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedDataService } from './shared-data.service';

@Injectable({
  providedIn: 'root',
})
export class CommonFunctionsService {
  constructor(private dataService: SharedDataService, private _router: Router) {}

  getRedirectedByRequestId(): void {
    this.dataService._getRequestId().subscribe((requestId) => {
      location.href = environment.base_url + '/authz-srv/authz/resolve_redirect/' + requestId;
    });
  }

  getRedirectedByRequestIdWithQueryParams(userIdHint: string): void {
    this.dataService._getRequestId().subscribe((requestId) => {
      location.href = environment.base_url + '/authz-srv/authz/resolve_redirect/' + requestId +'?userIdHint='+userIdHint ;
    });
  }
}
